export const questions = [
  {
    color: '#D2E3FC',
    bg: 'rgb(140,181,248)',
    src: '/images/question_1.png',
    questionKey: 'q1',
    headerText:
      'Right now, how effective are you at transforming data into value?',
    type: 'slider',
    help: `(1 being “Value, what value?”, 5 being "We're all about value!")`,
    insight: {
      text: [
        'Did you know,',
        ' 68% of companies ',
        'are unable to realize tangible & measurable value from data.',
      ] as string[],
      cite: 'Accenture’s Closing the data value gap',
      href: 'https://www.accenture.com/us-en/insights/technology/closing-data-value-gap'
    },
  },
  {
    color: '#FAD2CF',
    bg: 'rgb(242,143,134)',
    src: '/images/question_2.png',
    questionKey: 'q2',
    headerText:
      'My organization uses AI and Machine Learning in ways that accelerate our time to business value.',
    type: 'slider',
    help: `(1 strongly disagree, 5 strongly agree)`,
    insight: {
      text: [
        '',
        '75% of consumers',
        ' are more likely to make a purchase from a company that knows their name and purchase history.',
      ] as string[],
      cite: 'Accenture’s Interactive Personalization',
      href: 'https://newsroom.accenture.com/news/consumers-welcome-personalized-offerings-but-businesses-are-struggling-to-deliver-finds-accenture-interactive-personalization-research.htm'
    },
  },
  {
    color: '#FEEFC3',
    bg: 'rgb(253,214,99)',
    src: '/images/question_3.png',
    questionKey: 'q3',
    headerText:
      'How would you rank the sophistication of analytics capabilities within your organization?',
    type: 'order',
    options: [
      { text: 'Reporting and dashboards', value: 1 },
      { text: 'Visual discovery', value: 2 },
      { text: 'Prescriptive analytics', value: 3 },
      { text: 'Predictive analytics', value: 4 },
      {
        text: 'Advanced analytics & complex event stream processing',
        value: 5,
      },
    ] as Array<{ text: string; value: number }>,
    help: 'Drag, stack and rank from most sophisticated to least.',
    insight: {
      text: ['', '80% of analytics', ' work is still descriptive.'] as string[],
      cite: 'MIT’s 10 Best Practices for Analytics Success',
      href: 'https://mitsloan.mit.edu/ideas-made-to-matter/10-best-practices-analytics-success-including-3-you-cant-ignore#:~:text=Experts%20estimate%20that%2080%25%20of,why%20specific%20forecasts%20were%20off.'
    },
  },
  {
    color: '#CEEAD6',
    bg: 'rgb(92,185,117)',
    src: '/images/question_4.png',
    questionKey: 'q4',
    headerText:
      'The transactional systems that power our mission critical operations are reliable and secure.',
    type: 'slider',
    help: `(1 strongly disagree, 5 strongly agree)`,
  },
  {
    color: '#FAD2CF',
    bg: 'rgb(242,143,134)',
    src: '/images/question_5.png',
    questionKey: 'q5',
    headerText:
      'We know we have the right processes in place to keep our data secure, no matter where it resides.',
    type: 'slider',
    help: `(1 strongly disagree, 5 strongly agree)`,
  },
  {
    color: '#CEEAD6',
    bg: 'rgb(92,185,117)',
    src: '/images/question_6.png',
    questionKey: 'q6',
    headerText:
      'We have the right tools in place to govern the quality, accuracy, and compliance of data.',
    type: 'slider',
    help: `(1 strongly disagree, 5 strongly agree)`,
  },
  {
    color: '#D2E3FC',
    bg: 'rgb(140,181,248)',
    src: '/images/question_7.png',
    questionKey: 'q7',
    headerText:
      'We are well-protected from vendor lock-in because we deploy open solutions across multi-cloud.',
    type: 'slider',
    help: `(1 strongly disagree, 5 strongly agree)`,
  },
  {
    color: '#FEEFC3',
    bg: 'rgb(253,214,99)',
    src: '/images/question_8.png',
    questionKey: 'q8',
    headerText:
      'How does the following statement relate to the current setup at your organization? Select an item below that applies.',
    type: 'select',
    help: `"Business users have insights embedded into their existing workflows and tools, and users are capable of taking action without having to switch tools."`,
    last: true,
    insight: {
      text: [
        '',
        '66% of companies',
        ' still use spreadsheets for the majority of BI and analytics.',
      ] as string[],
      cite:
        'Source: Forrester Research, Business Technographics® Global Data And Analytics Survey',
    },
    options: [
      { text: 'No insights are available', value: 1 },
      { text: 'I have to ask another team for insights', value: 2 },
      {
        text: 'Insights are avaliable if I open up new tools to explore',
        value: 3,
      },
      {
        text:
          'Insights are available to me and assigned to another person / team to take action',
        value: 4,
      },
      {
        text:
          'Insights are integrated into my workflow and I can take action on most data within the same tool',
        value: 5,
      },
    ] as Array<{ text: string; value: number }>,
  },
] as const;
